import { format } from "date-fns";
import { useField, UseFieldProps } from "formik";
import { defaultDateFormat } from "../models/dates";
import { Maybe } from "../models/generated/graphql";
import { neo4jDateToDate } from "../utils/neo4j-date-to-date";
import DatePicker from "./date-range-picker/DatePicker";

export function FormDateRange(props: UseFieldProps<any>) {
	const [{ value, onChange, ...field }, { error }] = useField(props);

	function handleDateRangeChange(startDate?: Maybe<Date>, endDate?: Maybe<Date>) {
		onChange([startDate && format(startDate, defaultDateFormat), endDate && format(endDate, defaultDateFormat)]);
	}

	return (
		<DatePicker
			{...field}
			startDate={neo4jDateToDate(value?.[0])}
			endDate={neo4jDateToDate(value?.[1])}
			onChangeRange={handleDateRangeChange}
			error={error}
			checkDate={true}
			{...props}
		/>
	);
}
